export default __webpack_public_path__ + "static/media/Airplain.1259213e.png";